import React, { useEffect, useCallback } from 'react';
import * as Styles from './SignatureConfirmation.styles';
import { billingAnalytics } from '@/analytics';
import SupportForms from '@/components/SupportForms';
import useLocale from '@/hooks/useLocale/useLocale';
import { AlertV2 } from 'gatorcomponents';

const SignatureConfirmation = ({
  title = 'Please read the information below before confirming your cancellation:',
  attentionLabel = 'Attention',
  canShowBackupLink = true,
  backupFilesLabel = 'Please back up anything you want to save before continuing.',
  backupFilesLinkLabel = 'See how to back up your files',
  onClickBackupLink,
  subscription,
  subscriptions,
  handleAnswer,
  isAddonVPSOci,
  onStopCancel,
  stopCancelLabel = "I don't want to cancel the renewal anymore",
  attentionCancelSignatureLabel = 'By canceling this subscription, the following will occur:',
  attentionCancelExclusionLabel,
  topics = [
    'Your subscription will be canceled immediately, and you will lose access to the services you have with us.',
    'You will not be charged again for this subscription.',
  ],
  testId = 'confirmation',
}) => {
  const { ticket: ticketsLocale } = useLocale();
  const { subscriptions: subscriptionAnalytics } = billingAnalytics;

  const getProductNamePackageVPSOci = useCallback(() => {
    if (subscription && subscriptions) {
      const foundSubscription = subscriptions.find(subscriptionItem => subscriptionItem.addons && subscriptionItem.addons.includes(subscription.productName));
      return foundSubscription ? `${foundSubscription.productName} - ${foundSubscription.domain}` : '';
      // Caso altere o padrão, alterar também em useSupportForms.js -> label: `${product.name} - ${product.domain}`,
    }
    return '';
  }, [subscription, subscriptions]);

  useEffect(() => {
    subscriptionAnalytics.cancelSubscriptionPageView('6_confirmar_cancelamento_imediato');
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleOnStopCancelClick = () => {
    onStopCancel && onStopCancel();
  };

  const hadleOnClickBackupLink = () => {
    onClickBackupLink && onClickBackupLink();
  };

  const shouldShowFormRebuild = useCallback(() => isAddonVPSOci && isAddonVPSOci(), [isAddonVPSOci]);
  const contentSignatureCancel = (
    <Styles.Description>
      <Styles.AttentionCancelSignatureLabel>
        {attentionCancelSignatureLabel}
        {canShowBackupLink && ` ${backupFilesLabel}`}
      </Styles.AttentionCancelSignatureLabel>
      {attentionCancelExclusionLabel && (
        <Styles.AttentionCancelExclusionLabel>
          {attentionCancelExclusionLabel}
        </Styles.AttentionCancelExclusionLabel>
      )}
      {(topics.length > 0) && (
        <Styles.ListWrapper>
          <Styles.List>
            {topics.map((topic, index) => (
              <Styles.ListItem key={`${testId}-topic-${index + 1}`}>{ topic }</Styles.ListItem>
            ))}
          </Styles.List>
        </Styles.ListWrapper>
      )}
    </Styles.Description>
  );

  return (
    <Styles.Wrapper data-testid={testId}>
      <Styles.Title>
        {title}
      </Styles.Title>
      <AlertV2
        onPrimaryAction={handleOnStopCancelClick}
        primaryButtonLabel={stopCancelLabel}
        onSecondaryAction={canShowBackupLink && hadleOnClickBackupLink}
        secondaryButtonLabel={canShowBackupLink && backupFilesLinkLabel}
        title={attentionLabel}
        testId="alert"
        variant="critical"
        width="fit-content"
        withoutBackground={false}
        description={contentSignatureCancel}
      />

      {shouldShowFormRebuild() && (
        <Styles.SupportFormsWrapperVPSOciCancel>
          <SupportForms
            serviceType={{
              title: ticketsLocale.openNewTicketPage.titleRebuildVpsOci,
              onSuccess: handleAnswer,
              lockedOptions: true,
              defaultValues: {
                defaultSelectedProductOption: getProductNamePackageVPSOci(),
                defaultSelectedSector: 'technical',
                defaultSelectedNeed: ticketsLocale.forms.names.reloadRebuildVpsOci,
              },
            }}
          />
        </Styles.SupportFormsWrapperVPSOciCancel>
      )}
    </Styles.Wrapper>
  );
};

export default SignatureConfirmation;
